<template>
  <div class="convertersConfigAdd">
    <form>
      <div class="form-group">
        <h4 class="m-0 mt-3">
          {{ $t("converterConfigs.add") }}
        </h4>
        <hr class="m-0 mb-3" />
        <label>Name</label>
        <input
          v-model="connector.name"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('DisplayName') },
          ]"
          type="text"
        />
        <hr class="m-0 mb-4" />
        <label>{{ $t("locaion") }}</label>
        <select
          v-model="connector.service"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('Type') },
          ]"
        >
          <option
            v-for="(loc, index) in serviceTypes"
            :key="`spotType-spot-${index}`"
            :value="loc"
          >
            {{ `${loc}` }}
          </option>
        </select>
        <hr class="m-0 mb-4" />
        <label
          for="inputTypes"
          class="form-label"
        >{{
          $t("converterConfigs.inputTypes")
        }}</label>
        <Multiselect
          id="inputTypes"
          v-model="connector.types"
          tag-placeholder="Not found"
          placeholder="Select Input Types"
          :options="connectorTypes"
          select-label=""
          :multiple="true"
          :taggable="true"
          :hide-selected="true"
          :searchable="false"
          :close-on-select="true"
          class="mb-4"
        />
        <hr class="m-0 mb-3" />
        <label>URL</label>
        <input
          v-model="connector.url"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('DisplayName') },
          ]"
          type="text"
        />
        <hr class="m-0 mb-3" />
        <label>URL</label>
        <vue-json-editor
          v-model="connector.config"
          :show-btns="false"
          :mode="'code'"
          :expanded-on-start="true"
          @json-change="onJsonChange"
        />
      </div>
      <LoadingPlaceholder v-if="upsertLoading" />
      <button
        v-else
        class="btn btn-primary float-right"
        @click.prevent="createConverterConfig()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="check"
        />{{ $t("add") }}
      </button>
      <div class="clearfix" />
    </form>
  </div>
</template>

<script>
import { errorMixin } from "@/mixins/errorMixin.js";
import vueJsonEditor from "vue-json-editor";

export default {
  name: "ConvertersConfigAdd",
  components: {
    Multiselect: () => import("vue-multiselect"),
    vueJsonEditor
  },
  mixins: [errorMixin],
  props: {
    resortId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      connector: {
        config: [{}]
      },
      connectorTypes: [
        "SKIDATA",
        "OCC",
        "CHIP_NUMBER",
        "BARCODE",
        "PROJECT_POS_SERIAL",
        "WTP",
        "WTP_WIFI",
        "POS_SERIAL",
        "FERATEL",
        "GENERIC_NUMBER",
        "GENERIC",
        "SKILINE_TOKEN",
        "SWISSPASS",
        "TICKETCORNER",
      ],
      serviceTypes: [
        "SKIDATA_TDI",
        "SKIDATA_DAZ",
        "AXESS_DCI4WTP",
        "DSS_MYD",
        "SWISSPASS_KMW",
        "FERATEL_CHECKAPI",
        "BAQUEIRA",
      ],
      upsertLoading: false,
    };
  },
  methods: {
    onJsonChange(value) {
      this.connector.config = value;
    },
    createConverterConfig() {
      this.upsertLoading = true;
      this.connector.resortId = this.resortId
      this.axios
        .post("/ConverterConfig/AddConverterConfig", this.connector)
        .then(() => {
          this.$snotify.success(this.$t("converterConfigs.addedSuccessfully"));
          this.$emit("reload");
          this.error_clear();
          this.upsertLoading = false;
        })
        .catch((error) => {
          this.error_clear();
          this.error_validate(error);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.ace-jsoneditor {
  min-height: 300px;
}
</style>